import React from 'react';
import ProcessingStatusButton from './processing-status-button';
import { useGetActivityStatus } from 'api/baker';

// for local dev only, this is not used in deployed frontends. you may provide any valid activity id
const MOCK_ACTIVITY_LIST = ['5aee6b26-768d-45ff-bdd3-669d0b8f19f7', '7f00b666-f5b6-4110-b4e3-6b1f81e26876'];

const MemoizedProcessingStatusButton = React.memo(ProcessingStatusButton, (prev, next) => {
    return JSON.stringify(prev.activityStatuses) === JSON.stringify(next.activityStatuses); // prevents re-renders when the activitiesData changes reference rather than its actual contents
});

export const ActivityStatusContainer: React.FC = () => {
    const isDevEnvironment = process.env.REACT_APP_ENVIRONMENT === 'dev';

    const { statuses: activityStatuses } = useGetActivityStatus(MOCK_ACTIVITY_LIST, isDevEnvironment);

    return <MemoizedProcessingStatusButton activityStatuses={activityStatuses} />;
};
